import React from 'react'
import { colors } from '@mobi/component-library/Foundations'
import { SharedBetCard } from '@core/Areas/BetLoop/Components/Common/SharedBetCard'
import {
  getBetLoopShareBetType,
  trackBetLoopNotificationOpened,
} from '@core/Areas/BetLoop/helpers/analytics'
import type { IncomingBetLoopShare } from './types'
import { trackShareBetLinkOpen } from '@core/Areas/ShareBet/helpers/analytics'

export const IncomingSharedBet: React.FC<{
  incomingShare: IncomingBetLoopShare
}> = ({ incomingShare }) => {
  const highlightRef = React.useRef<HTMLDivElement>(null)
  const [hasCalledAnalyticsTracking, setHasCalledAnalyticsTracking] = React.useState<boolean>(false)

  React.useEffect(() => {
    if (!highlightRef.current) return

    if (!hasCalledAnalyticsTracking) {
      if (incomingShare.isExternalIncomingShare) {
        trackShareBetLinkOpen({
          share_origin: incomingShare.sharedBet.ownerAccountId,
          betType: getBetLoopShareBetType(incomingShare.sharedBet),
        })
      } else {
        trackBetLoopNotificationOpened(incomingShare.sharedBet)
      }

      setHasCalledAnalyticsTracking(true)
    }

    const el = highlightRef.current
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    el.style.transition = 'outline 0.75s ease'
    el.style.outline = `2px solid ${colors.mariner[500]}`

    const timeMs = incomingShare.sharedBet.isResulted ? 6_000 : 2_500
    const timerId = window.setTimeout(() => {
      el.style.outline = '2px solid transparent'
    }, timeMs)

    return () => clearTimeout(timerId)
  }, [incomingShare, hasCalledAnalyticsTracking])

  return (
    <SharedBetCard
      ref={highlightRef}
      sharedBet={incomingShare.sharedBet}
      shouldAutoOpenQuickbet={
        incomingShare.betOptionTab === 'pending-bets' && !incomingShare.isViewOnly
      }
      isExternalBetLoopShare={incomingShare.isExternalIncomingShare}
    />
  )
}
